// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General container styling */
.MaterialRegistration-container {
  max-width: 900px;
  margin: 20px auto;
  padding: 20px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

/* Title styling */
.MaterialRegistration-title {
  font-size: 24px;
  font-weight: bold;
  color: #333333;
  text-align: center;
  margin-bottom: 20px;
}

.MaterialRegistration-controls {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
  justify-content: space-between;
}
/* Search input */
.MaterialRegistration-search {
  /* flex: 1; */
  min-width: 500px;
  padding: 10px;
  border: 1px solid #cccccc;
  border-radius: 4px;
  font-size: 14px;
  color: #333333;
}

.MaterialRegistration-search:focus {
  outline: none;
  /* border-color: #007bff; */
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.3);
}

/* Add button */
.MaterialRegistration-add-btn {
  padding: 10px 20px;
  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.MaterialRegistration-add-btn:hover {
  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);
}

/* Table container for responsiveness */
.MaterialRegistration-table-container {
  overflow-x: auto;
}

/* Table styling */
.MaterialRegistration-table {
  width: 100%;
  border-collapse: collapse;
  background-color: #ffffff;
}

.MaterialRegistration-table th,
.MaterialRegistration-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
}

.MaterialRegistration-table th {
  background-color: #f5f5f5;
  font-weight: bold;
  color: #333333;
  font-size: 14px;
}

.MaterialRegistration-table tr:hover {
  background-color: #f9f9f9;
}

/* No data message */
.MaterialRegistration-no-data {
  text-align: center;
  color: #666666;
  padding: 20px;
}

/* Action buttons */
.MaterialRegistration-edit-btn,
.MaterialRegistration-delete-btn {
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  margin-right: 5px;
  transition: background-color 0.2s;
}

.MaterialRegistration-edit-btn {
  background: linear-gradient(
    135deg,
    rgba(13, 110, 253, 0.1),
    rgba(13, 110, 253, 0.2)
  );
  color: #0d6efd;
}

.MaterialRegistration-edit-btn:hover {
  background: linear-gradient(
    135deg,
    rgba(13, 110, 253, 0.2),
    rgba(13, 110, 253, 0.3)
  );
  color: #0d6efd;
}

.MaterialRegistration-delete-btn {
  background: linear-gradient(
    135deg,
    rgba(220, 53, 69, 0.1),
    rgba(220, 53, 69, 0.2)
  );
  color: #dc3545;
}

.MaterialRegistration-delete-btn:hover {
  background: linear-gradient(
    135deg,
    rgba(220, 53, 69, 0.2),
    rgba(220, 53, 69, 0.3)
  );
}

/* Overlay for popup */
.MaterialRegistration-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Form container */
.MaterialRegistration-form-container {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 8px;
  position: relative;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

/* Close button */
.MaterialRegistration-close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 20px;
  color: #666666;
  cursor: pointer;
}

.MaterialRegistration-close-btn:hover {
  color: #333333;
}

/* Form title */
.MaterialRegistration-form-title {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  margin-bottom: 15px;
  text-align: center;
}

/* Form styling */
.MaterialRegistration-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

/* Form input */
.MaterialRegistration-input {
  padding: 10px;
  border: 1px solid #cccccc;
  border-radius: 4px;
  font-size: 14px;
  color: #333333;
}

.MaterialRegistration-input:focus {
  outline: none;
  /* border-color: #007bff; */
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.3);
}

/* Submit button */
.MaterialRegistration-submit-btn {
  padding: 10px;
  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.MaterialRegistration-submit-btn:hover {
  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);
}

.MaterialRegistration-submit-btn:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

/* Responsive design */
@media (max-width: 768px) {
  .MaterialRegistration-container {
    margin: 10px;
    padding: 15px;
  }

  .MaterialRegistration-title {
    font-size: 20px;
  }

  .MaterialRegistration-controls {
    flex-direction: column;
  }

  .MaterialRegistration-search {
    width: 100%;
  }

  .MaterialRegistration-add-btn {
    width: 100%;
    padding: 12px;
  }

  .MaterialRegistration-table th,
  .MaterialRegistration-table td {
    padding: 8px;
    font-size: 13px;
  }

  .MaterialRegistration-edit-btn,
  .MaterialRegistration-delete-btn {
    padding: 6px 10px;
    font-size: 12px;
  }

  .MaterialRegistration-form-container {
    padding: 15px;
    max-width: 90%;
  }
}

@media (max-width: 480px) {
  .MaterialRegistration-title {
    font-size: 18px;
  }

  .MaterialRegistration-table th,
  .MaterialRegistration-table td {
    padding: 6px;
    font-size: 12px;
  }

  .MaterialRegistration-form-title {
    font-size: 16px;
  }

  .MaterialRegistration-input,
  .MaterialRegistration-submit-btn {
    font-size: 13px;
    padding: 8px;
  }

  .MaterialRegistration-close-btn {
    font-size: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Registration/MaterialRegistration.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,8BAA8B;AAChC;AACA,iBAAiB;AACjB;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA,uCAAuC;AACvC;EACE,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA,mBAAmB;AACnB;;EAEE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE;;;;GAIC;EACD,cAAc;AAChB;;AAEA;EACE;;;;GAIC;EACD,cAAc;AAChB;;AAEA;EACE;;;;GAIC;EACD,cAAc;AAChB;;AAEA;EACE;;;;GAIC;AACH;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,eAAe;AACf;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,6DAA6D;EAC7D,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;;IAEE,YAAY;IACZ,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* General container styling */\n.MaterialRegistration-container {\n  max-width: 900px;\n  margin: 20px auto;\n  padding: 20px;\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n/* Title styling */\n.MaterialRegistration-title {\n  font-size: 24px;\n  font-weight: bold;\n  color: #333333;\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.MaterialRegistration-controls {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 20px;\n  justify-content: space-between;\n}\n/* Search input */\n.MaterialRegistration-search {\n  /* flex: 1; */\n  min-width: 500px;\n  padding: 10px;\n  border: 1px solid #cccccc;\n  border-radius: 4px;\n  font-size: 14px;\n  color: #333333;\n}\n\n.MaterialRegistration-search:focus {\n  outline: none;\n  /* border-color: #007bff; */\n  box-shadow: 0 0 5px rgba(0, 123, 255, 0.3);\n}\n\n/* Add button */\n.MaterialRegistration-add-btn {\n  padding: 10px 20px;\n  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);\n  color: #ffffff;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.MaterialRegistration-add-btn:hover {\n  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);\n}\n\n/* Table container for responsiveness */\n.MaterialRegistration-table-container {\n  overflow-x: auto;\n}\n\n/* Table styling */\n.MaterialRegistration-table {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: #ffffff;\n}\n\n.MaterialRegistration-table th,\n.MaterialRegistration-table td {\n  padding: 12px;\n  text-align: left;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.MaterialRegistration-table th {\n  background-color: #f5f5f5;\n  font-weight: bold;\n  color: #333333;\n  font-size: 14px;\n}\n\n.MaterialRegistration-table tr:hover {\n  background-color: #f9f9f9;\n}\n\n/* No data message */\n.MaterialRegistration-no-data {\n  text-align: center;\n  color: #666666;\n  padding: 20px;\n}\n\n/* Action buttons */\n.MaterialRegistration-edit-btn,\n.MaterialRegistration-delete-btn {\n  padding: 8px 12px;\n  border: none;\n  border-radius: 4px;\n  font-size: 13px;\n  cursor: pointer;\n  margin-right: 5px;\n  transition: background-color 0.2s;\n}\n\n.MaterialRegistration-edit-btn {\n  background: linear-gradient(\n    135deg,\n    rgba(13, 110, 253, 0.1),\n    rgba(13, 110, 253, 0.2)\n  );\n  color: #0d6efd;\n}\n\n.MaterialRegistration-edit-btn:hover {\n  background: linear-gradient(\n    135deg,\n    rgba(13, 110, 253, 0.2),\n    rgba(13, 110, 253, 0.3)\n  );\n  color: #0d6efd;\n}\n\n.MaterialRegistration-delete-btn {\n  background: linear-gradient(\n    135deg,\n    rgba(220, 53, 69, 0.1),\n    rgba(220, 53, 69, 0.2)\n  );\n  color: #dc3545;\n}\n\n.MaterialRegistration-delete-btn:hover {\n  background: linear-gradient(\n    135deg,\n    rgba(220, 53, 69, 0.2),\n    rgba(220, 53, 69, 0.3)\n  );\n}\n\n/* Overlay for popup */\n.MaterialRegistration-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n/* Form container */\n.MaterialRegistration-form-container {\n  background-color: #ffffff;\n  padding: 20px;\n  border-radius: 8px;\n  position: relative;\n  width: 90%;\n  max-width: 400px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n/* Close button */\n.MaterialRegistration-close-btn {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: none;\n  border: none;\n  font-size: 20px;\n  color: #666666;\n  cursor: pointer;\n}\n\n.MaterialRegistration-close-btn:hover {\n  color: #333333;\n}\n\n/* Form title */\n.MaterialRegistration-form-title {\n  font-size: 18px;\n  font-weight: bold;\n  color: #333333;\n  margin-bottom: 15px;\n  text-align: center;\n}\n\n/* Form styling */\n.MaterialRegistration-form {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n/* Form input */\n.MaterialRegistration-input {\n  padding: 10px;\n  border: 1px solid #cccccc;\n  border-radius: 4px;\n  font-size: 14px;\n  color: #333333;\n}\n\n.MaterialRegistration-input:focus {\n  outline: none;\n  /* border-color: #007bff; */\n  box-shadow: 0 0 5px rgba(0, 123, 255, 0.3);\n}\n\n/* Submit button */\n.MaterialRegistration-submit-btn {\n  padding: 10px;\n  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);\n  color: #ffffff;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.MaterialRegistration-submit-btn:hover {\n  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);\n}\n\n.MaterialRegistration-submit-btn:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .MaterialRegistration-container {\n    margin: 10px;\n    padding: 15px;\n  }\n\n  .MaterialRegistration-title {\n    font-size: 20px;\n  }\n\n  .MaterialRegistration-controls {\n    flex-direction: column;\n  }\n\n  .MaterialRegistration-search {\n    width: 100%;\n  }\n\n  .MaterialRegistration-add-btn {\n    width: 100%;\n    padding: 12px;\n  }\n\n  .MaterialRegistration-table th,\n  .MaterialRegistration-table td {\n    padding: 8px;\n    font-size: 13px;\n  }\n\n  .MaterialRegistration-edit-btn,\n  .MaterialRegistration-delete-btn {\n    padding: 6px 10px;\n    font-size: 12px;\n  }\n\n  .MaterialRegistration-form-container {\n    padding: 15px;\n    max-width: 90%;\n  }\n}\n\n@media (max-width: 480px) {\n  .MaterialRegistration-title {\n    font-size: 18px;\n  }\n\n  .MaterialRegistration-table th,\n  .MaterialRegistration-table td {\n    padding: 6px;\n    font-size: 12px;\n  }\n\n  .MaterialRegistration-form-title {\n    font-size: 16px;\n  }\n\n  .MaterialRegistration-input,\n  .MaterialRegistration-submit-btn {\n    font-size: 13px;\n    padding: 8px;\n  }\n\n  .MaterialRegistration-close-btn {\n    font-size: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
